<ion-header [translucent]="true">
  <ion-toolbar color="success">
    <ion-buttons slot="start">
    <ion-button (click)="cancelar()">
      <ion-icon name="arrow-back-outline"/>
    </ion-button>
    </ion-buttons>
    <ion-title>{{ titulo }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="save()" type="submit">
        <ion-icon   name="save"></ion-icon>
      </ion-button>
      <ion-button *ngIf="deletavel" color="danger" (click)="delete()" >
        <ion-icon  name="trash"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
